import React from "react";
import {connect} from "react-redux";
import {Form, Formik} from "formik";
import {traerPalabrasTabla} from "../../_actions";
import {history, prepareDataSearch} from "../../_helpers";
import {ventasService} from "../../_services";
import {buscadorConstants} from "../../_constants";
import Moment from "react-moment";
import {busquedaActions} from "../../_actions/busqueda.actions";
import MiTabla from "../../_helpers/MiTabla";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { NumericFormat as NumberFormat } from "react-number-format";
import {Link} from "react-router-dom";
import alertService from "../../_services/cart/alert.service";
import authService from "../../_services/cart/authService";
import {Tab, Tabs} from "react-bootstrap";
import {VentaDP} from "../vendedor/ventas/utils/ventasUtils";
import {NavBarLateral} from "../includes";
import FiltrosDashboard from "../includes/FiltrosDashboard";

const tableRefPendientePago = React.createRef();
const tableRefCancelada = React.createRef();
const tableRefFinalizada = React.createRef();
const tableRefPagada = React.createRef();
const tableRefPendienteEntrega = React.createRef();

const bagRefVentas = React.createRef();
const bagRef = React.createRef();
const _ = require("lodash");

class VentasAdminList extends React.Component {
    constructor(props) {
        super(props);
        this.state.nuevo = _.clone(buscadorConstants.infoTablaDefault);
    }

    state = {
        loading: false,
        tipoKey: 'PENDIENTE_PAGO',
        nuevaBusqueda: false,
        show: false,
        producto: {},
        showProductModal: false,
        values: {}
    };

    componentDidMount() {
        const {filtros} = this.props;

        if (filtros === undefined) this.props.traerFiltros();
    }

    actualizarFromTab = (tipoKey) => {
        if (tipoKey === 'PENDIENTE_ENTREGA' && tableRefPendienteEntrega.current) {
            tableRefPendienteEntrega.current.onQueryChange();
        }

        if (tipoKey === 'PAGADA' && tableRefPagada.current) {
            tableRefPagada.current.onQueryChange();
        }

        if (tipoKey === 'FINALIZADA' && tableRefFinalizada.current) {
            tableRefFinalizada.current.onQueryChange();
        }

        if (tipoKey === 'PENDIENTE_PAGO' && tableRefPendientePago.current) {
            tableRefPendientePago.current.onQueryChange();
        }

        if (tipoKey === 'CANCELADA' && tableRefCancelada.current) {
            tableRefCancelada.current.onQueryChange();
        }
    };

    actualizarPageSize = (newPageSIze) => {
        if (tableRefPendientePago.current && this.state.tipoKey === 'PENDIENTE_PAGO') {
            tableRefPendientePago.current.dataManager.changePageSize(newPageSIze)
        }

        if (tableRefPagada.current && this.state.tipoKey === 'PAGADA') {
            tableRefPagada.current.dataManager.changePageSize(newPageSIze)
        }

        if (tableRefCancelada.current && this.state.tipoKey === 'CANCELADA') {
            tableRefCancelada.current.dataManager.changePageSize(newPageSIze)
        }

        if (tableRefPendienteEntrega.current && this.state.tipoKey === 'PENDIENTE_ENTREGA') {
            tableRefPendienteEntrega.current.dataManager.changePageSize(newPageSIze)
        }

        if (tableRefFinalizada.current && this.state.tipoKey === 'FINALIZADA') {
            tableRefFinalizada.current.dataManager.changePageSize(newPageSIze)
        }

    };

    actualizar = () => {
        if (tableRefPendientePago.current && this.state.tipoKey === 'PENDIENTE_PAGO') {
            tableRefPendientePago.current.onQueryChange();
        }

        if (tableRefPagada.current && this.state.tipoKey === 'PAGADA') {
            tableRefPagada.current.onQueryChange();
        }

        if (tableRefCancelada.current && this.state.tipoKey === 'CANCELADA') {
            tableRefCancelada.current.onQueryChange();
        }

        if (tableRefPendienteEntrega.current && this.state.tipoKey === 'PENDIENTE_ENTREGA') {
            tableRefPendienteEntrega.current.onQueryChange();
        }

        if (tableRefFinalizada.current && this.state.tipoKey === 'FINALIZADA') {
            tableRefFinalizada.current.onQueryChange();
        }
    };

    handleClose = () => {
        this.setState({
            showProductModal: false,
            producto: undefined,
            alert: undefined,
        });
    };

    buscarData = (query, booleano, status) => {
        return new Promise((resolve, reject) => {
            if (this.state.nuevaBusqueda) query.page = 0;

            let valuesToSend = this.state.values;
            valuesToSend.estado = status;

            ventasService
                .buscarVentasTodas(
                    prepareDataSearch(query, "createdDate", "DESC", valuesToSend)
                )
                .then(
                    (data) => {
                        this.setState({nuevaBusqueda: false});
                        resolve({
                            data: data.content ? data.content : [],
                            page: query.page,
                            totalCount: data ? data.totalElements : 0,
                        });
                        this.actualizarPageSize(query.pageSize);
                    },
                    (error) => {
                        alertService.error(error);
                    }
                );
        });
    };

    render() {
        if (!authService.hasAuthority("ADMIN")) {
            history.push('/');
        }

        const {filtros} = this.props;

        const {loading} = this.state;

        const tableStyle = {
            tableLayout: "auto",
            width: "100%",
            maxWidth: "100%",
            height: "auto",
            borderRadius: "1rem",
            border: "1px solid #d2d2d2",
            boxShadow: 'none',
            backgroundColor: 'inherit',
            color: 'inherit'
        }

        const header = [
            {title: "ID", field: "id"},
            {
                title: "Comprador",
                field: "comprador.username",
                render: (row) => {
                    return authService.formatUserName(row.comprador);
                },
            },
            {
                title: "Vendedor",
                field: "vendedor.username",
                render: (row) => {
                    return authService.formatUserName(row.vendedor);
                },
            },
            {
                title: "Cantidad productos",
                // En mobile no entra en la card: el dato completo esta en el detalle.
                mobile: false,
                // `cantidad` no existe en Venta: el numero sale de items.length en el front,
                // asi que la columna no puede ordenarse contra la DB.
                sorting: false,
                render: (row) => {
                    return row.items.length;
                },
            },
            {
                title: "Total",
                field: "total",
                render: (row) => {
                    return (
                        <NumberFormat
                            prefix={"$"}
                            value={row.total}
                            displayType={"text"}
                            thousandSeparator="."
                            decimalSeparator=","
                        />
                    );
                },
            },

            {title: "Estado", field: "estado"},
            {
                title: "Fecha Venta",
                field: "createdDate",
                render: (row) => (
                    <Moment date={row.createdDate} format="DD/MM/YYYY HH:mm"/>
                ),
            },
            {
                title: "",
                cellStyle: {textAlign: "center"},
                render: (row) => (
                    <div className="table-button">
                        <Link to={"/comprador/compraDetail?id=" + row.id}>
                            <FontAwesomeIcon className={'button'} data-type={'complementary-smallest'}
                                             icon="fa-solid fa-eye"></FontAwesomeIcon>
                        </Link>
                    </div>
                ),
            },
        ];

        const options = {
            search: true,
            sorting: true,
            fontSize: 6,
            filtering: false,
            selection: false,
            pageSize: this.state.nuevo.limit ?? 10,
            pageSizeOptions: [5, 10, 25, 30, 50, 75, 100],
            exportAllData: true,
            overflowX: "auto",
            tableLayout: "auto",
        };

        let inic = {
            lugar: {id: undefined},
            nombre: undefined,
            estado: {id: undefined},
        };

        return (
            <>
                <div className="dashboard">
                    <NavBarLateral handleClose={this.handleClose}/>

                    <div className="dashboard__content">
                        <Formik
                            enableReinitialize={true}
                            innerRef={bagRef}
                            initialValues={inic}
                            onSubmit={(values) => {
                                this.setState(
                                    {
                                        values: values,
                                        nuevaBusqueda: true,
                                    },
                                    this.actualizar
                                );
                            }}
                        >
                            {({values, setFieldValue, submitForm}) => (
                                <Form>
                                    <div className="dashboard__content-header">
                                        <div className="dashboard__content-title">
                                            <h2>Ventas</h2>
                                        </div>
                                    </div>
                                    <div className="filter__container">
                                        <FiltrosDashboard
                                            forVenta={true}
                                            values={values}
                                            filtros={filtros}
                                            setFieldValue={setFieldValue}
                                            submitForm={submitForm}
                                        ></FiltrosDashboard>
                                    </div>

                                    <Tabs
                                        id="controlled-tab-example"
                                        activeKey={this.state.tipoKey}
                                        onSelect={(k) => this.setState({
                                            tipoKey: k,
                                            nuevaBusqueda: true
                                        }, this.actualizarFromTab(k))}
                                        className=""
                                    >
                                        <Tab eventKey="PENDIENTE_PAGO" title="Pendientes de Pago">
                                            <div className="dashboard__content-main--tab">
                                                <MiTabla
                                                    title=""
                                                    tableRef={tableRefPendientePago}
                                                    columns={header}
                                                    options={options}
                                                    style={tableStyle}
                                                    data={(query) => this.buscarData(query, false, 'PENDIENTE_PAGO')}
                                                    detailPanel={(rowData) => {
                                                        return <VentaDP rowData={rowData}/>;
                                                    }}
                                                    localization={traerPalabrasTabla("Ventas")}
                                                />
                                            </div>
                                        </Tab>

                                        <Tab eventKey="PAGADA" title="Pagadas">
                                            <div className="dashboard__content-main--tab">
                                                <MiTabla
                                                    title=""
                                                    tableRef={tableRefPagada}
                                                    columns={header}
                                                    options={options}
                                                    style={tableStyle}
                                                    data={(query) => this.buscarData(query, false, 'PAGADA')}
                                                    detailPanel={(rowData) => {
                                                        return <VentaDP rowData={rowData}/>;
                                                    }}
                                                    localization={traerPalabrasTabla("Ventas")}
                                                /></div>
                                        </Tab>

                                        <Tab eventKey="PENDIENTE_ENTREGA" title="Pendientes de Entrega">
                                            <div className="dashboard__content-main--tab">
                                                <MiTabla
                                                    title=""
                                                    tableRef={tableRefPendienteEntrega}
                                                    columns={header}
                                                    options={options}
                                                    style={tableStyle}
                                                    data={(query) => this.buscarData(query, false, 'PENDIENTE_ENTREGA')}
                                                    detailPanel={(rowData) => {
                                                        return <VentaDP rowData={rowData}/>;
                                                    }}
                                                    localization={traerPalabrasTabla("Ventas")}
                                                />
                                            </div>
                                        </Tab>

                                        <Tab eventKey="FINALIZADA" title="Finalizadas">
                                            <div className="dashboard__content-main--tab">
                                                <MiTabla
                                                    title=""
                                                    tableRef={tableRefFinalizada}
                                                    columns={header}
                                                    options={options}
                                                    style={tableStyle}
                                                    data={(query) => this.buscarData(query, false, 'FINALIZADA')}
                                                    detailPanel={(rowData) => {
                                                        return <VentaDP rowData={rowData}/>;
                                                    }}
                                                    localization={traerPalabrasTabla("Ventas")}
                                                /></div>
                                        </Tab>

                                        <Tab eventKey="CANCELADA" title="Canceladas">
                                            <div className="dashboard__content-main--tab">
                                                <MiTabla
                                                    title=""
                                                    tableRef={tableRefCancelada}
                                                    columns={header}
                                                    options={options}
                                                    style={tableStyle}
                                                    data={(query) => this.buscarData(query, false, 'CANCELADA')}
                                                    detailPanel={(rowData) => {
                                                        return <VentaDP rowData={rowData}/>;
                                                    }}
                                                    localization={traerPalabrasTabla("Ventas")}
                                                /></div>
                                        </Tab>

                                    </Tabs>

                                </Form>
                            )}
                        </Formik>

                        {this.state.alert}
                    </div>
                </div>
            </>
        );
    }
}

function mapState(state) {
    const {filtros} = state.busqueda;
    return {filtros};
}

const actionCreators = {
    traerFiltros: busquedaActions.traerFiltros,
};

const connectedVentasAdminList = connect(mapState, actionCreators)(VentasAdminList);
export {connectedVentasAdminList as VentasAdminList};
